import React from "react";
import FormaPagos from "./FormaPagos";
import FormaDebito from "./FormaDebito";

const FormaPago = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_FORMA_PAGO, GET_FORMA_DEBITO, ERROR_PRODUCT } = data;
    const existDebitoEncuenta = GET_FORMA_PAGO.some( g => g.EsDebitoEnCuenta && g.Checked && g.Activo );
    let formaPagoDefault = data.FormaPagoDefaultId;
    let hayDebitoDefault = GET_FORMA_PAGO.some( g => g.EsDebitoEnCuenta && g.Id == formaPagoDefault );
    

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <div className="row bottom-separator">
                    <div className="col-xs-12">
                        <h2>{"Forma de Pago"}</h2>
                    </div>
                </div>

                <FormaPagos
                    data={data}
                    formaPagos={GET_FORMA_PAGO}
                    seleccionoFormaPago={ERROR_PRODUCT.seleccionoFormaPago}
                    selectCheckBox={selectCheckBox}
                    selectCombo={selectCombo} />

                {existDebitoEncuenta
                    && <FormaDebito
                        cuentaConDebitoEnDefault={hayDebitoDefault}
                        tipoDebitoDefaultId={data.TipoDebitoDefaultId}
                        tipoDebitoDefaultInterfaz={data.TipoDebitoDefaultInterfaz}
                        formaPagoDebitos={GET_FORMA_DEBITO}
                        seleccionoFormaPagoDebito={ERROR_PRODUCT.seleccionoFormaPagoDebito}
                        selectCheckBox={selectCheckBox}
                        selectCombo={selectCombo} />}
            </div>
        </div>
    );
}

export default FormaPago;